module.exports = __webpack_public_path__ + "e0d947b5255fb08fa1808b1689441a8f.svg";